import { render, staticRenderFns } from "./AppHeaderGrid.vue?vue&type=template&id=071b52a0&scoped=true&"
import script from "./AppHeaderGrid.vue?vue&type=script&lang=ts&"
export * from "./AppHeaderGrid.vue?vue&type=script&lang=ts&"
import style0 from "./AppHeaderGrid.vue?vue&type=style&index=0&id=071b52a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071b52a0",
  null
  
)

export default component.exports